import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestLastComments } from '../../../SHARED/actions/comments.actions.js';
import { API_URL } from "../../../SHARED/config/apiEndpoints";
import { Link } from 'react-router-dom';
import imgProfile from '../../resources/img/user-icon.png';
import Moment from "react-moment";
import 'moment/locale/ro';
import Parser from 'html-react-parser';
import {slugify} from '../../../SHARED/helpers/general.helper'

class LastComments extends Component {

    componentWillMount() {
        this.props.requestLastComments();
    }



    viewArticles(comment) {
        if (comment.field_name === "article_comments"){
            return (
                <Link to={`stire/${comment.comment_entity_id}/${slugify(comment.comment_entity_title)}`} className="white-text">
                    {comment.comment_entity_title}
                </Link>
            )
        } else if (comment.field_name === 'film_ratings'){
            return (
                <Link to={`film/${comment.comment_entity_id}/${slugify(comment.comment_entity_title)}`} className="white-text">
                    {comment.comment_entity_title}
                </Link>
            )
        }
    }

    getLastComments() {
        return this.props.lastComments.map((comment, i) => (
                <div className="comment-item clearfix" key={i}>
                    <div className="lefty">
                        <img alt={'Comentariu'} className="img-fluid rounded-circle" src={ comment.comment_author_image !== "" ? API_URL + Parser(comment.comment_author_image) : imgProfile}/>
                    </div>
                    <div className="righty float-left">
                        <div className="comment-date">
                            <Moment format="DD MMMM YYYY HH:mm" locale="ro" unix>
                                { comment.comment_created }
                            </Moment>
                        </div>
                        <div className="comment-activity"><span className="comment-name">{ comment.comment_author_first_name }</span> a comentat despre</div>
                        <div className="comment-movie">{this.viewArticles(comment)}</div>
                    </div>
                    <div className="comment-content">
                        { comment.comment_text } <br/>
                        <span className="white-text">__ __ __</span>
                    </div>
                  
                </div>
            )
        );
    }

    render() {
        return (
            <div className="last-comments">

                <div className="row">
                    <div className="col-12">
                        <p>Ultimele comentarii</p>
                        { this.getLastComments() }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    lastComments: state.comments.lastComments
});
export default connect(mapStateToProps, {requestLastComments})(LastComments);



// WEBPACK FOOTER //
// ./src/FO/components/lastcomments/lastcomments.component.js